import { render, staticRenderFns } from "./RegisterRequest.vue?vue&type=template&id=6030dc08&scoped=true&"
import script from "./RegisterRequest.vue?vue&type=script&lang=ts&"
export * from "./RegisterRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030dc08",
  null
  
)

export default component.exports